import mime from 'mime';

export class Utils {

    static getClientIconSource(baseType: string): string {
        const baseUrl = 'assets/icons/client-types';
        switch (baseType) {
            case 'Company':
                return `${baseUrl}/company.svg`;
            case 'Trust':
                return `${baseUrl}/trust.svg`;
            case 'Fund Acc':
                return `${baseUrl}/fund-account.svg`;
            case 'Fund Mgr':
                return `${baseUrl}/fund-manager.svg`;
            case 'Partnership':
                return `${baseUrl}/partnership.svg`;
            case 'Foundation':
                return `${baseUrl}/foundation.svg`;
            case 'Estate':
                return `${baseUrl}/estate.svg`;
            default:
                return `${baseUrl}/other.svg`;
        }
    }

    static getClientIconTitle(baseType: string): string {
        switch (baseType) {
            case 'Company':
                return 'Company';
            case 'Trust':
                return 'Trust';
            case 'Fund Acc':
                return 'Fund Account';
            case 'Fund Mgr':
                return 'Fund Manager';
            case 'Partnership':
                return 'Partnership';
            case 'Foundation':
                return 'Foundation';
            case 'Estate':
                return 'Estate';
            default:
                return 'Unknown Entity Type';
        }
    }

    static getInvoiceStatusIconSource(status: string): string {
        const baseUrl = 'assets/icons/common';
        if (status === 'Paid') {
            return `${baseUrl}/invoice-status-paid.svg`;
        } else {
            return `${baseUrl}/invoice-status-outstanding.svg`;
        }
    }

    static base64ToBlob(base64String: string, fileExtension: string): Blob {
        const byteArrays = [];
        if (base64String) {
            const byteCharacters = atob(base64String);
            const sliceSize = 512;
            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.codePointAt(i) ?? 0;
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
        }
        return new Blob(byteArrays, {type: mime.getType(fileExtension)});
    }

    static getFileIconSource(fileExtension: string): string {
        const baseIconPath = 'assets/icons/documents/';
        switch (fileExtension) {
            case 'docx':
                return baseIconPath + 'file-doc.svg';
            case 'xlsx':
                return baseIconPath + 'file-xls.svg';
            case 'pptx':
                return baseIconPath + 'file-ppt.svg';
            case 'pdf':
                return baseIconPath + 'file-pdf.svg';
            case 'jpg':
            case 'jpeg':
            case 'png':
                return baseIconPath + 'file-img.svg';
        }
        return baseIconPath + 'file-generic.svg';
    }

    static getFileIconIsGeneric(fileExtension: string): boolean {
        switch (fileExtension) {
            case 'docx':
            case 'xlsx':
            case 'pptx':
            case 'pdf':
            case 'jpg':
            case 'jpeg':
            case 'png':
                return false;
            default:
                return true;
        }
    }

    static getFormattedFileExtension(fileExtension: string): string {
        if (fileExtension?.length > 0) {
            return fileExtension.replace('.', '');
        } else {
            return '';
        }
    }

    static getUserStatusText(status?: number): string {
        switch (status) {
            case 1:
                return 'Draft';
            case 2:
                return 'Pending First Login';
            case 3:
                return 'Active';
            case 4:
                return 'Sync Error';
            case 5:
                return 'Inactive';
            default:
                return 'Unknown';
        }
    }
}
